<style lang="scss" scoped>
@use 'sass:color';
@use '../../palette.scss' as *;

.content-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: bold;
    margin: 0 10px 10px;
    border-top: 1px solid $theme-light-grey;
    padding: 8px 5px;

    .fa-plus {
        margin-right: 4px;
    }
}

.personnel-body {
    display: flex;
    flex-direction: column;

    .content-split {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        width: 100%;
        gap: 5px;
    }

    .left-panel,
    .right-panel {
        width: 50%;
        display: flex;
        flex-direction: column;
    }

    .left-panel {
        align-items: center; /* centers content horizontally */
        justify-content: center; /* centers vertically */
    }

    .right-panel {
        align-items: flex-start;
    }

    .add-container {
        display: flex;
        flex-flow: column;
        padding: 10px;

        .user-block {
            width: 100%;
        }

        .row {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            flex-wrap: wrap;
            gap: 5px;
            width: 100%;
        }

        .control-row {
            display: flex;
            justify-content: center;
            align-items: center;

            margin: 5px 0;

            button {
                min-width: 150px;
            }

            .dropdown-container {
                min-width: 180px;
            }

            .fa-plus {
                margin-right: 4px;
            }
        }
    }

    .users-container {
        display: flex;
        flex-flow: column;
        margin: 0 15px;
        width: 100%;

        .user-block {
            padding: 10px 0;
            margin-right: 20px;

            & > span {
                font-weight: bold;
            }

            .user-row {
                display: flex;
                align-items: center;
                text-indent: -5px;
                padding: 0 30px 0 8px;
                word-break: break-word;
                position: relative;
                width: 100%;

                &:hover {
                    .delete-btn-ctn {
                        opacity: 1;
                    }
                }

                .delete-btn-ctn {
                    transition: opacity 0.25s;
                    position: absolute;
                    opacity: 0;
                    right: 0;

                    button {
                        background-color: transparent;
                        color: $theme-red;
                        font-size: 1.7em;
                        border: none;
                        outline: none;

                        i {
                            border-radius: 50%;

                            &:hover {
                                background-color: color.adjust(
                                    $theme-red,
                                    $alpha: -0.85
                                );
                                color: color.adjust(
                                    $theme-red,
                                    $lightness: -5%
                                );
                            }

                            &:active {
                                transform: scale(0.97);
                            }
                        }
                    }
                }
            }
        }
    }
}

.error {
    color: red;
}

.campaign-list {
    min-height: 150px;
    width: 100%;

    &.collapsible {
        min-height: 0;
        padding: 10px;
    }

    .button-row {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-bottom: 10px;
        margin-right: 10px;
    }

    .heading-row {
        display: flex;
        align-items: center;
        padding-right: 55px;
        border-bottom: 1px solid $theme-light-grey;
        margin-bottom: 15px;

        .heading {
            display: flex;
            align-items: center;
            border-right: 1px solid $theme-light-grey;
            width: 20%;
            font-size: 1.1em;
            padding: 10px;

            &:hover {
                background-color: color.adjust($theme-light-grey, $alpha: -0.7);
                cursor: pointer;
            }

            &:active {
                background-color: color.adjust(
                    color.adjust($theme-light-grey, $alpha: -0.7),
                    $lightness: -10%
                );
            }

            &.last {
                border-right: none;
            }
        }
    }

    .campaign-card-container {
        position: relative;
        display: flex;
        align-items: center;

        &:hover,
        &.swiped {
            .campaign-card {
                &:not(.enabled) {
                    margin-right: 55px;

                    .card-contents {
                        width: 100%;
                    }
                }
            }
        }

        &.spaced {
            margin-bottom: 10px;
        }

        .delete-btn-ctn {
            position: absolute;
            width: 55px;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            top: 0;
            right: 0;
            z-index: 0;

            button {
                margin: 0 5px 10px 0;
            }

            button {
                background-color: transparent;
                color: $theme-red;
                font-size: 1.7em;
                border: none;
                outline: none;

                i {
                    border-radius: 50%;

                    &:hover {
                        background-color: color.adjust(
                            $theme-red,
                            $alpha: -0.85
                        );
                        background-color: color.adjust(
                            $theme-red,
                            $lightness: -5%
                        );
                    }

                    &:active {
                        transform: scale(0.97);
                    }
                }
            }
        }

        .campaign-card {
            padding: 10px;
            box-shadow: $subtle-shadow;
            border-radius: 5px;
            border: 1px solid $theme-light-grey;
            transition: margin 0.25s;
            z-index: 5;
            width: 100%;
            background-color: white;

            &:hover:not(.no-hover) {
                cursor: pointer;
                background-color: color.adjust(white, $lightness: -5%);
            }

            &:active:not(.no-hover) {
                transform: scale(0.99);
            }

            &:not(.no-hover) {
                .button-block .button {
                    background-color: white;
                }
            }

            .button-block .fa-spinner {
                animation: spin 1s infinite;
            }

            @keyframes spin {
                from {
                    transform: rotate(0);
                }
                to {
                    transform: rotate(360deg);
                }
            }

            .card-contents {
                width: calc(100% - 55px);
                transition: width 0.25s;

                .title {
                    color: $theme-blue;
                    font-weight: bold;
                }

                .id {
                    color: color.adjust($theme-light-grey, $lightness: -5%);
                    font-style: italic;
                    font-size: 0.9em;
                    font-weight: bold;
                }

                .label-box {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 30%;
                }

                .property-block {
                    display: flex;
                    align-items: baseline;

                    .property-col {
                        display: flex;
                        flex-flow: column;
                        width: 20%;

                        .label-component {
                            margin-bottom: 1rem;
                        }

                        &.center {
                            align-items: center;
                        }

                        &.alert {
                            color: $theme-red;
                            font-weight: bold;
                            font-size: 1.1em;

                            &.none {
                                color: $theme-green;
                            }

                            .report-count {
                                margin-top: 10px;
                                color: $theme-dark-grey;
                                font-weight: normal;
                                font-size: 0.9em;
                            }
                        }

                        .unit-name {
                            font-weight: bold;
                            margin-left: 10%;
                        }
                    }

                    @media (min-width: 1000px) {
                        background-color: transparent;
                    }
                }
            }
        }
    }

    .collapsible-block {
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        width: 100%;

        .fa-caret-down {
            position: absolute;
            right: 10px;
            top: 4px;
        }
    }
}

.modal-label {
    font-weight: bold;
}

.input-box-container {
    margin: 0 20px;
}

.clone-body {
    .value {
        padding: 0 10%;
        text-align: center;
        margin: 10px 0;
    }

    .input-block {
        display: flex;
        justify-content: center;

        .input-box-container {
            width: 80%;
        }
    }
}

.spinner-block {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-around;

    .spinner-container {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 60px;
        width: 60px;

        .blocks {
            position: relative;
            width: 100%;
            height: 100%;

            .block {
                position: absolute;
                width: 35%;
                height: 35%;
                border-radius: 3px;
                animation-duration: 0.5s;
                animation-iteration-count: infinite;
                animation-timing-function: linear;

                &.one {
                    left: 10%;
                    top: 10%;
                    animation-name: blockone;
                    background-color: $theme-dark-blue;
                }

                &.two {
                    left: 55%;
                    top: 10%;
                    animation-name: blocktwo;
                    background-color: $theme-blue;
                }

                &.three {
                    left: 55%;
                    top: 55%;
                    animation-name: blockthree;
                    background-color: $theme-light-blue;
                }

                @keyframes blockone {
                    50% {
                        left: 10%;
                        top: 10%;
                        background-color: $theme-dark-blue;
                    }

                    100% {
                        left: 55%;
                        top: 10%;
                        background-color: $theme-blue;
                    }
                }

                @keyframes blocktwo {
                    25% {
                        left: 55%;
                        top: 10%;
                        background-color: $theme-blue;
                    }

                    50% {
                        left: 55%;
                        top: 55%;
                        background-color: $theme-light-blue;
                    }

                    100% {
                        left: 55%;
                        top: 55%;
                        background-color: $theme-light-blue;
                    }
                }

                @keyframes blockthree {
                    0% {
                        left: 55%;
                        top: 55%;
                        background-color: $theme-light-blue;
                    }

                    50% {
                        left: 10%;
                        top: 55%;
                        background-color: color.adjust(
                            $theme-blue,
                            $lightness: 20%
                        );
                    }

                    75% {
                        left: 10%;
                        top: 55%;
                        background-color: color.adjust(
                            $theme-blue,
                            $lightness: 20%
                        );
                    }

                    100% {
                        left: 10%;
                        top: 10%;
                        background-color: $theme-dark-blue;
                    }
                }
            }
        }

        .fa,
        .fas {
            font-size: 2em;

            &.fa-check {
                color: $theme-green;
            }

            &.fa-location-arrow {
                color: $theme-grey;
            }
        }
    }

    .dots {
        flex-grow: 1;
        border-bottom: 2px dotted $theme-light-grey;
        margin: 0 15px;
    }
}

.delete-block {
    min-width: 240px;
    width: 70%;
    margin: 15px 15% 0;
    background-color: color.adjust($theme-red, $alpha: -0.9);
    box-shadow: $subtle-shadow;
    border-radius: 5px;
    padding: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .hold-delete-btn {
        border-radius: 3px;
        background-color: color.adjust($theme-red, $alpha: -0.6);
        color: $theme-red;
        margin-bottom: 15px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 4px 8px;
        font-weight: bold;

        &:hover {
            cursor: pointer;
            color: color.adjust($theme-red, $lightness: -5%);
            background-color: color.adjust(
                color.adjust($theme-red, $alpha: -0.6),
                $lightness: -5%
            );
        }

        &:active {
            transform: scale(0.98);
        }
    }

    .delete-bar-ctn {
        background-color: color.adjust($theme-red, $alpha: -0.9);
        border-radius: 3px;
        width: 70%;
        height: 8px;

        .delete-bar {
            background-color: $theme-red;
            height: 100%;
            border-radius: 3px;
        }
    }
}

::v-deep(.modal-footer button) {
    margin-right: 10px;
}

::v-deep(.modal-footer button:last-child) {
    margin-right: 0;
}
</style>

<template>
    <Card color="blue" fullWidth>
        <template #header>{{ $t('campaignAdministration') }}</template>
        <template #body>
            <div class="campaign-list">
                <div class="button-row">
                    <Button @click="openAddCampaign" outline circle>
                        <i class="fa fa-plus"></i>
                    </Button>
                </div>
                <div class="heading-row">
                    <div class="heading" @click="setSortType('NAME')">
                        {{ $t('name') }}
                    </div>
                    <div class="heading" @click="setSortType('LAST_ACTIVITY')">
                        {{ $t('lastActivity') }}
                    </div>
                    <div class="heading" @click="setSortType('HEALTH')">
                        {{ $t('health') }}
                    </div>
                    <div class="heading" @click="setSortType('UNIT')">
                        {{ $t('unit') }}
                    </div>
                    <div class="heading last" @click="setSortType('ACTIONS')">
                        {{ $t('action_plural') }}
                    </div>
                </div>
                <v-touch
                    v-for="campaign in unarchived"
                    :key="campaign.id"
                    class="campaign-card-container spaced"
                    v-touch:tap="() => selectCampaign(campaign)"
                >
                    <div
                        class="campaign-card"
                        :class="{
                            'no-hover': buttonHover,
                            enabled: campaign.enabled,
                        }"
                        @click="selectCampaign(campaign)"
                    >
                        <div class="card-contents">
                            <div class="property-block">
                                <div class="property-col">
                                    <p class="title">{{ campaign.name }}</p>
                                    <span class="id"
                                        >id: {{ campaign.id }}</span
                                    >
                                </div>
                                <div class="property-col">
                                    <p>{{ getCampaignDateString(campaign) }}</p>
                                    <p>{{ getCampaignTimeString(campaign) }}</p>
                                </div>
                                <div
                                    class="property-col alert"
                                    :class="{
                                        none:
                                            getUnacknowledgedAlerts(campaign) <
                                            1,
                                    }"
                                    v-tooltip.left="$t('healthTooltip')"
                                >
                                    <span class="alert-count">
                                        <i
                                            class="fa fa-exclamation-circle"
                                            v-if="
                                                getUnacknowledgedAlerts(
                                                    campaign,
                                                ) > 0
                                            "
                                        ></i>
                                        <i
                                            class="fa fa-check-circle"
                                            v-else
                                        ></i>
                                        {{ getUnacknowledgedAlerts(campaign) }}
                                        / {{ getTotalAlerts(campaign) }}
                                    </span>
                                    <span class="report-count"
                                        >{{ $t('message_plural') }}:
                                        {{ getMessageCount(campaign) }}
                                    </span>
                                </div>
                                <div class="property-col">
                                    <p class="unit-name">
                                        {{ getUnitOnCampaign(campaign) }}
                                    </p>
                                </div>
                                <div class="property-col center">
                                    <Label
                                        outline
                                        transparent
                                        :color="
                                            campaign.enabled ? 'green' : 'red'
                                        "
                                    >
                                        {{
                                            campaign.enabled
                                                ? $t('enabled')
                                                : $t('disabled')
                                        }}
                                    </Label>
                                    <div
                                        class="button-block"
                                        @mouseover="buttonHover = true"
                                        @mouseleave="buttonHover = false"
                                    >
                                        <Button
                                            small
                                            outline
                                            @click.stop="
                                                openCloneModal(campaign)
                                            "
                                            v-tooltip.bottom="$t('clone')"
                                        >
                                            <i class="fa fa-copy"></i>
                                        </Button>
                                        <Button
                                            small
                                            outline
                                            @click.stop="
                                                downloadDataDump(campaign)
                                            "
                                            v-tooltip.bottom="$t('download')"
                                        >
                                            <i
                                                class="fas fa-download"
                                                :class="{
                                                    'fa-spinner':
                                                        downloadingId ===
                                                        campaign.id,
                                                    'fa-download':
                                                        downloadingId !==
                                                        campaign.id,
                                                }"
                                            >
                                            </i>
                                        </Button>
                                        <Button
                                            small
                                            outline
                                            @click.stop="
                                                showArchiveModal(campaign)
                                            "
                                            v-tooltip.bottom="$t('archive')"
                                            v-if="!campaign.enabled"
                                        >
                                            <i class="fas fa-archive"></i>
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="delete-btn-ctn">
                        <button @click="promptCampaignDelete(campaign)">
                            <i class="far fa-times-circle" />
                        </button>
                    </div>
                </v-touch>
                <Collapsible
                    :isOpen="archivedOpen"
                    @toggle="archivedOpen = !archivedOpen"
                    v-if="archived.length > 0"
                >
                    <template #button>
                        <div class="collapsible-block">
                            <span>{{ $t('archived') }}</span>
                            <i class="fa fa-caret-down"></i>
                        </div>
                    </template>
                    <template #content>
                        <div class="campaign-list collapsible">
                            <v-touch
                                v-for="(campaign, index) in archived"
                                :key="campaign.id"
                                class="campaign-card-container spaced"
                                :class="{ spaced: index < archived.length - 1 }"
                                v-touch:tap="() => selectCampaign(campaign)"
                            >
                                <div
                                    class="campaign-card"
                                    :class="{ 'no-hover': buttonHover }"
                                    @click="selectCampaign(campaign)"
                                >
                                    <div class="card-contents">
                                        <div class="property-block">
                                            <div class="property-col">
                                                <p class="title">
                                                    {{ campaign.name }}
                                                </p>
                                                <span class="id"
                                                    >id: {{ campaign.id }}</span
                                                >
                                            </div>
                                            <div class="property-col">
                                                <p>
                                                    {{
                                                        getCampaignDateString(
                                                            campaign,
                                                        )
                                                    }}
                                                </p>
                                                <p>
                                                    {{
                                                        getCampaignTimeString(
                                                            campaign,
                                                        )
                                                    }}
                                                </p>
                                            </div>
                                            <div
                                                class="property-col alert"
                                                :class="{
                                                    none:
                                                        getUnacknowledgedAlerts(
                                                            campaign,
                                                        ) < 1,
                                                }"
                                                v-tooltip.left="
                                                    $t('healthTooltip')
                                                "
                                            >
                                                <span class="alert-count">
                                                    <i
                                                        class="fa fa-exclamation-circle"
                                                        v-if="
                                                            getUnacknowledgedAlerts(
                                                                campaign,
                                                            ) > 0
                                                        "
                                                    ></i>
                                                    <i
                                                        class="fa fa-check-circle"
                                                        v-else
                                                    ></i>
                                                    {{
                                                        getUnacknowledgedAlerts(
                                                            campaign,
                                                        )
                                                    }}
                                                    /
                                                    {{
                                                        getTotalAlerts(campaign)
                                                    }}
                                                </span>
                                                <span class="report-count"
                                                    >{{ $t('message_plural') }}:
                                                    {{
                                                        getMessageCount(
                                                            campaign,
                                                        )
                                                    }}
                                                </span>
                                            </div>
                                            <div class="property-col">
                                                <p class="unit-name">
                                                    {{
                                                        getUnitOnCampaign(
                                                            campaign,
                                                        )
                                                    }}
                                                </p>
                                            </div>
                                            <div class="property-col center">
                                                <Label outline transparent>
                                                    {{ $t('archived') }}
                                                </Label>
                                                <div
                                                    class="button-block"
                                                    @mouseover="
                                                        buttonHover = true
                                                    "
                                                    @mouseleave="
                                                        buttonHover = false
                                                    "
                                                >
                                                    <Button
                                                        small
                                                        outline
                                                        @click.stop="
                                                            openCloneModal(
                                                                campaign,
                                                            )
                                                        "
                                                        v-tooltip.bottom="
                                                            $t('clone')
                                                        "
                                                    >
                                                        <i
                                                            class="fa fa-copy"
                                                        ></i>
                                                    </Button>
                                                    <Button
                                                        small
                                                        outline
                                                        @click.stop="
                                                            downloadDataDump(
                                                                campaign,
                                                            )
                                                        "
                                                        v-tooltip.bottom="
                                                            $t('download')
                                                        "
                                                    >
                                                        <i
                                                            class="fas fa-download"
                                                            :class="{
                                                                'fa-spinner':
                                                                    downloadingId ===
                                                                    campaign.id,
                                                                'fa-download':
                                                                    downloadingId !==
                                                                    campaign.id,
                                                            }"
                                                        >
                                                        </i>
                                                    </Button>
                                                    <Button
                                                        small
                                                        outline
                                                        @click.stop="
                                                            showUnarchiveModal(
                                                                campaign,
                                                            )
                                                        "
                                                        v-tooltip.bottom="
                                                            $t('unarchive')
                                                        "
                                                    >
                                                        <i
                                                            class="fas fa-box-open"
                                                        ></i>
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="delete-btn-ctn">
                                    <button
                                        @click="promptCampaignDelete(campaign)"
                                    >
                                        <i class="far fa-times-circle" />
                                    </button>
                                </div>
                            </v-touch>
                        </div>
                    </template>
                </Collapsible>
            </div>
        </template>
    </Card>

    <!-- Add new campaign modal -->
    <Modal v-if="showAddCampaign" @ok="addCampaign" @cancel="closeAddCampaign">
        <template #header>
            <h3>{{ $t('createCampaign') }}</h3>
        </template>
        <template #body>
            <div>
                <div class="center-flex">
                    <span class="modal-label">{{ $t('name') }}</span>
                    <InputBox
                        type="text"
                        center
                        v-model="newCampaignName"
                        ref="addCampaignInput"
                    ></InputBox>
                </div>
            </div>
            <span v-if="isErrorVisible" class="error" v-html="nameError"></span>
            <br />
            <div v-if="isUserAdmin">
                <div class="content-header">
                    <span>{{ $t('organizationManagement') }}</span>
                </div>
                <span
                    v-if="isErrorVisible"
                    class="error"
                    v-html="errorMessage"
                ></span>
                <div class="personnel-body">
                    <div class="content-split">
                        <div class="left-panel">
                            <div class="add-container">
                                <div
                                    style="
                                        display: flex;
                                        gap: 12px;
                                        width: 100%;
                                    "
                                >
                                    <div class="user-block" style="flex: 2">
                                        <div class="row">
                                            <div class="control-row">
                                                <DropdownMenu
                                                    :options="userOptions"
                                                    :maxHeight="'200px'"
                                                    outline
                                                    @change="setSelectedAddUser"
                                                    :value="
                                                        selectedAddUser.user_id
                                                    "
                                                ></DropdownMenu>
                                            </div>
                                            <div class="control-row">
                                                <Button
                                                    small
                                                    @click="addManager"
                                                    :disabled="
                                                        !selectedAddUserValidManager
                                                    "
                                                >
                                                    <i class="fa fa-plus"></i>
                                                    {{ $t('manager') }}
                                                </Button>
                                            </div>

                                            <div class="control-row">
                                                <DropdownMenu
                                                    :options="
                                                        organizationOptions
                                                    "
                                                    :maxHeight="'200px'"
                                                    outline
                                                    @change="
                                                        setSelectedAddOrganization
                                                    "
                                                    :value="
                                                        selectedAddOrganization.id
                                                    "
                                                ></DropdownMenu>
                                            </div>
                                            <div class="control-row">
                                                <Button
                                                    small
                                                    @click="addOrganization"
                                                    :disabled="
                                                        !selectedAddOrganizationValidManager
                                                    "
                                                >
                                                    <i class="fa fa-plus"></i>
                                                    {{ $t('organization') }}
                                                </Button>
                                            </div>
                                        </div>
                                        <div class="vertical-separator"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="right-panel">
                            <div class="users-container">
                                <div class="user-block" style="flex: 1">
                                    <span>{{ $t('manager_plural') }}</span>
                                    <div
                                        class="user-row"
                                        v-for="manager in managers"
                                        :key="manager.user_id"
                                    >
                                        {{ manager.name }}
                                        <div
                                            class="delete-btn-ctn"
                                            v-if="
                                                isUserAdmin ||
                                                ((isOrganizationAdmin ||
                                                    isCampaignManager) &&
                                                    !isOrgManager[
                                                        manager.user_id
                                                    ])
                                            "
                                        >
                                            <button
                                                @click="deleteManager(manager)"
                                            >
                                                <i
                                                    class="far fa-times-circle"
                                                ></i>
                                            </button>
                                        </div>
                                    </div>

                                    <div class="user-block">
                                        <span>{{
                                            $t('organization_plural')
                                        }}</span>
                                        <div
                                            class="user-row"
                                            v-for="organization in campaignOrganizations"
                                            :key="organization.id"
                                        >
                                            {{ organization.name }}
                                            <div
                                                class="delete-btn-ctn"
                                                v-if="
                                                    isUserAdmin ||
                                                    ((isOrganizationAdmin ||
                                                        isCampaignManager) &&
                                                        !isAdminOrg[
                                                            organization.id
                                                        ])
                                                "
                                            >
                                                <button
                                                    @click="
                                                        deleteSelectedOrganization(
                                                            organization.id,
                                                        )
                                                    "
                                                >
                                                    <i
                                                        class="far fa-times-circle"
                                                    ></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </Modal>

    <!-- Clone campaign modal -->
    <Modal
        v-if="showCloneCampaign"
        @ok="doCloneCampaign"
        @cancel="closeCloneModal"
    >
        <template #header>
            <h3>{{ $t('cloneCampaign') }}</h3>
        </template>
        <template #body>
            <div>
                <div class="clone-body">
                    <div class="modal-label">{{ $t('currentName') }}</div>
                    <div class="value">{{ actionCampaign.name }}</div>
                    <div class="modal-label">{{ $t('newName') }}</div>
                    <div class="input-block">
                        <InputBox
                            type="text"
                            center
                            v-model="cloneCampaignName"
                            ref="nameInput"
                        ></InputBox>
                    </div>
                </div>
            </div>
        </template>
    </Modal>

    <!-- Archive campaign modal -->
    <Modal
        v-if="showArchiveCampaign"
        @ok="doArchiveCampaign"
        @cancel="showArchiveCampaign = false"
    >
        <template #header>
            <h3>{{ $t('archiveCampaign') }}</h3>
        </template>
        <template #body>
            <div>
                <div class="modal-label">{{ $t('areYouSure') }}</div>
                <!-- Put this warning back in if/when archiving becomes irreversible -->
                <!-- <div>{{ $t('archiveWarning') }}</div> -->
            </div>
        </template>
    </Modal>

    <!-- Unarchive campaign modal -->
    <Modal
        v-if="showUnarchiveCampaign"
        @ok="doUnarchiveCampaign"
        @cancel="showUnarchiveCampaign = false"
    >
        <template #header>
            <h3>{{ $t('unarchiveCampaign') }}</h3>
        </template>
        <template #body>
            <div>
                <div class="modal-label">{{ $t('areYouSure') }}</div>
            </div>
        </template>
    </Modal>

    <!-- Delete campaign modal -->
    <Modal
        v-if="showDeleteCampaign"
        hideOk
        @cancel="showDeleteCampaign = false"
    >
        <template #header>
            <h3>{{ $t('deleteCampaign') }}</h3>
        </template>
        <template #body>
            <div>
                <div class="modal-label">{{ $t('areYouSure') }}</div>
                <div class="delete-block" v-if="!deleteInProgress">
                    <div class="hold-delete-btn" @mousedown="startHoldDelete">
                        {{ $t('holdToDelete') }}
                    </div>
                    <div class="delete-bar-ctn">
                        <div
                            class="delete-bar"
                            :style="{ width: `${deleteHoldProgress}%` }"
                        ></div>
                    </div>
                </div>
                <div class="spinner-block" v-else>
                    <div class="spinner-container">
                        <div class="blocks">
                            <div class="block one"></div>
                            <div class="block two"></div>
                            <div class="block three"></div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </Modal>
</template>

<script>
import { reactive } from 'vue';
import { mapState, mapGetters } from 'vuex';
import toastr from 'toastr';

import {
    addCampaign,
    cloneCampaign,
    deleteCampaign,
    updateCampaign,
    setManagers,
    setOrganizations,
    getCampaignList,
} from '../../api/campaigns';
import { STATUS_OK, STATUS_ERROR } from '../../api/client';
import { getAgeString } from '../../util/util';
import { SORT_TYPES } from '../../constants';
import { getOrganizationUser } from '../../api/organizations';

export default {
    data() {
        return {
            newCampaignName: '',
            cloneCampaignName: '',
            showAddCampaign: false,
            showCloneCampaign: false,
            showArchiveCampaign: false,
            showUnarchiveCampaign: false,
            showDeleteCampaign: false,
            archivedOpen: false,
            cloneCampaign: null,
            buttonHover: false, // Whether the user is hovering over the action buttons
            ageLoop: undefined,
            campaignAges: reactive({}),
            downloadingId: -1, // Id of campaign for data dump download
            sortType: SORT_TYPES.NAME,

            // Used for holding delete button for campaigns
            holdDeleteStart: 0,
            deleteHoldProgress: 0,
            deleteHoldUpdateLoop: null,
            DELETE_HOLD_TIMEOUT: 1000,
            deleteInProgress: false, // True when the request for delete is actually pending

            selectedAddUser: { invalid: true },
            selectedAddOrganization: { invalid: true },
            campaignOrganizations: [],
            managers: [],
            isErrorVisible: false,
            saveFailText: '',
            errorMessage: '',
            nameError: '',
        };
    },

    computed: {
        ...mapState(['campaignList', 'authToken']),

        ...mapGetters([
            'isUserAdmin',
            'isOrganizationAdmin',
            'isCampaignManager',
        ]),

        archived() {
            let archivedCampaigns = [];
            this.campaigns.forEach((c) => {
                if (c.archived) {
                    archivedCampaigns.push(c);
                }
            });
            return archivedCampaigns;
        },

        unarchived() {
            let unarchivedCampaigns = [];
            this.campaigns.forEach((c) => {
                if (!c.archived || c.archived === false) {
                    unarchivedCampaigns.push(c);
                }
            });
            return unarchivedCampaigns;
        },

        campaigns() {
            const alphabeticalList = [...this.campaignList].sort(
                this.$store.getters.intlCompareByName,
            );

            // Return whatever sorting of campaigns has been chosen by the user
            switch (this.sortType) {
                case SORT_TYPES.LAST_ACTIVITY:
                    // Filter names that have most recently reported to the top
                    return alphabeticalList.sort((a, b) => {
                        const aTime = new Date(a.last_activity).valueOf();
                        const bTime = new Date(b.last_activity).valueOf();
                        if (aTime > bTime) {
                            return -1;
                        } else if (aTime < bTime) {
                            return 1;
                        } else {
                            return 0;
                        }
                    });
                case SORT_TYPES.HEALTH:
                    // Here, campaigns with more unacknowledged alerts should be filtered
                    //  to the top of the list
                    return alphabeticalList.sort((a, b) => {
                        if (a.unacknowledged_alerts > b.unacknowledged_alerts) {
                            return -1;
                        } else if (
                            a.unacknowledged_alerts < b.unacknowledged_alerts
                        ) {
                            return 1;
                        } else {
                            return 0;
                        }
                    });
                case SORT_TYPES.UNIT:
                    // Organize campaigns into groups by the unit they're associated with,
                    //  then alphabetize the unit names, rearrange the groups appropriately
                    //  and return the new list
                    const unitNames = [];
                    const unitsByGroup = {};
                    const noUnitCampaigns = [];
                    for (const c of alphabeticalList) {
                        if (c.unit_name) {
                            unitNames.push(c.unit_name);
                            if (unitsByGroup[c.unit_name]) {
                                unitsByGroup[c.unit_name].push(c);
                            } else {
                                unitsByGroup[c.unit_name] = [c];
                            }
                        } else {
                            noUnitCampaigns.push(c);
                        }
                    }

                    const alphabeticalUnits = unitNames.sort(
                        this.$store.getters.intlCompareByName,
                    );
                    let campaignsByUnit = [];
                    for (const name of alphabeticalUnits) {
                        campaignsByUnit = campaignsByUnit.concat(
                            unitsByGroup[name],
                        );
                    }
                    // Add on campaigns without an associated unit
                    campaignsByUnit = campaignsByUnit.concat(noUnitCampaigns);

                    return campaignsByUnit;
                case SORT_TYPES.ACTIONS:
                    // Move the active campaigns up and filter out the ones that are inactive
                    return alphabeticalList.sort((a, b) => {
                        if (a.enabled && !b.enabled) {
                            return -1;
                        } else if (!a.enabled && b.enabled) {
                            return 1;
                        } else {
                            return 0;
                        }
                    });
                default:
                    return alphabeticalList;
            }
        },

        dateOnlyFormatter() {
            return new Intl.DateTimeFormat(this.$store.state.lang, {
                weekday: 'short',
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                timeZone: this.$store.state.timeFormatUtc ? 'UTC' : undefined,
            });
        },

        timeOnlyFormatter() {
            return new Intl.DateTimeFormat(this.$store.state.lang, {
                hour: 'numeric',
                minute: 'numeric',
                hour12: !this.$store.state.timeFormatUtc,
                timeZone: this.$store.state.timeFormatUtc ? 'UTC' : undefined,
                timeZoneName: 'short',
            });
        },

        usersList() {
            return this.$store.state.userList;
        },

        alphabeticalUsers() {
            return this.usersList
                .slice()
                .sort(this.$store.getters.intlCompareByName);
        },

        userOptions() {
            const users = this.alphabeticalUsers;
            if (users && users.length > 0) {
                const options = users.reduce((options, user) => {
                    options.push({
                        label: user.name,
                        value: user.id,
                    });
                    return options;
                }, []);
                return options;
            }
            return [];
        },

        organizations() {
            return this.$store.state.organizations;
        },

        organizationOptions() {
            return this.organizations.map((org) => ({
                label: org.organization_name,
                value: Number(org.id),
            }));
        },

        selectedAddUserValidManager() {
            if (this.selectedAddUser) {
                // Check to see if this user is already a manager
                if (this.managers) {
                    for (const manager of this.managers) {
                        if (this.selectedAddUser.user_id === manager.user_id) {
                            return false;
                        }
                    }
                }

                return true;
            }
            return false;
        },

        selectedAddOrganizationValidManager() {
            if (this.selectedAddOrganization) {
                // Check to see if this organization is already added
                if (this.campaignOrganizations) {
                    for (const organization of this.campaignOrganizations) {
                        if (
                            this.selectedAddOrganization.id === organization.id
                        ) {
                            return false;
                        }
                    }
                }

                return true;
            }
            return false;
        },
    },

    created: async function () {
        this.updateCampaignAges();
        window.addEventListener('mouseup', this.clearDeleteHolding);

        this.ageLoop = setTimeout(this.updateCampaignAges, 1000);
    },

    beforeDestroy() {
        window.removeEventListener('mouseup', this.clearDeleteHolding);
        this.clearDeleteHolding();
        if (this.ageLoop) {
            clearTimeout(this.ageLoop);
            this.ageLoop = undefined;
        }
    },

    methods: {
        openAddCampaign() {
            this.showAddCampaign = true;
            // We need next tick because vue hasn't processed the v-if to render the modal yet,
            //  so the ref we want to access here doesn't yet exist
            this.$nextTick(() => {
                this.$refs.addCampaignInput.setFocus();
            });
        },

        async addCampaign() {
            this.nameError = '';
            this.saveFailText = '';
            if (!this.newCampaignName) {
                this.nameError = this.$t('requireName');
            }

            // if not system admin default add logged in user organization information because
            // it will not be asked for in the modal but required during saving operation.
            if (!this.isUserAdmin) {
                let userOrg;
                const orgUser = await getOrganizationUser(
                    this.$store.state.currentUser.id,
                );
                if (orgUser.payload) {
                    userOrg = this.organizations.find(
                        (o) => o.id === orgUser.payload.organization_id,
                    );
                }
                // setup structures to store as default manager and organization
                let manager = {
                    user_id: this.$store.state.currentUser.id,
                    name: this.$store.state.currentUser.name,
                };
                let organization = {
                    id: parseInt(userOrg.id),
                    name: userOrg.organization_name,
                };
                this.managers = [manager];
                this.campaignOrganizations = [organization];
            }

            let response = null;
            let responseManagers = null;
            let responseOrganizations = null;

            if (
                this.managers.length < 1 ||
                this.campaignOrganizations.length < 1
            ) {
                response = { status: STATUS_ERROR, msg: '' };
                if (this.managers.length < 1) {
                    responseManagers = {
                        status: STATUS_ERROR,
                        msg: this.$t('requireManager'),
                    };
                } else {
                    responseManagers = { status: STATUS_OK, msg: '' };
                }
                if (this.campaignOrganizations.length < 1) {
                    responseOrganizations = {
                        status: STATUS_ERROR,
                        msg: this.$t('requireOrganization'),
                    };
                } else {
                    responseOrganizations = { status: STATUS_OK, msg: '' };
                }
            } else {
                response = await addCampaign(this.newCampaignName);
                if (response.status === STATUS_OK) {
                    responseManagers = await setManagers(
                        response.payload.id,
                        this.managers,
                    );
                }

                if (
                    responseManagers != null &&
                    responseManagers.status === STATUS_OK
                ) {
                    responseOrganizations = await setOrganizations(
                        response.payload.id,
                        this.campaignOrganizations,
                    );
                }
            }
            if (
                response.status === STATUS_ERROR ||
                responseManagers.status === STATUS_ERROR ||
                responseOrganizations.status === STATUS_ERROR
            ) {
                this.saveFailed = true;
                this.saveSucceeded = false;

                if (response.status === STATUS_ERROR && response.msg) {
                    this.saveFailText = this.$t(
                        response.msg,
                        response.msg_data,
                    );
                }
                if (
                    responseManagers.status === STATUS_ERROR &&
                    responseManagers.msg
                ) {
                    if (this.saveFailText.length > 0) {
                        this.saveFailText += '<br>';
                    }
                    this.saveFailText += this.$t(
                        responseManagers.msg,
                        responseManagers.msg_data,
                    );
                }
                if (
                    responseOrganizations.status === STATUS_ERROR &&
                    responseOrganizations.msg
                ) {
                    if (this.saveFailText.length > 0) {
                        this.saveFailText += '<br>';
                    }
                    this.saveFailText += this.$t(
                        responseOrganizations.msg,
                        responseOrganizations.msg_data,
                    );
                }

                this.isErrorVisible = true;
                this.errorMessage = this.saveFailText;
            } else if (
                response.status === STATUS_OK &&
                responseManagers.status === STATUS_OK &&
                responseOrganizations.status === STATUS_OK
            ) {
                this.saveFailText = '';
                this.saveFailed = false;
                this.saveSucceeded = true;

                toastr.success(this.$t('campaignCreateSuccessful'));

                // Refresh campaign list from server to ensure new campaign is visible
                // before setting it as active. This prevents the campaign from briefly
                // appearing then disappearing for non-admin users.
                if (response.payload) {
                    const updatedList = await getCampaignList();
                    if (updatedList && updatedList.payload) {
                        this.$store.commit(
                            'setCampaignList',
                            updatedList.payload,
                        );
                    }

                    this.$store.commit('setCampaignId', {
                        campaignId: response.payload.id,
                        campaignName: response.payload.name,
                    });
                }
                this.closeAddCampaign();
                return;
            }
        },

        closeAddCampaign() {
            this.showAddCampaign = false;
            this.newCampaignName = '';
            this.campaignOrganizations = [];
            this.managers = [];
        },

        closeCloneModal() {
            this.showCloneCampaign = false;
            this.cloneCampaignName = '';
        },

        doArchiveCampaign: async function () {
            // For now, just call the update endpoint with the archive flag set
            const response = await updateCampaign({
                ...this.actionCampaign,
                archived: true,
            });
            if (response.status === STATUS_OK) {
                toastr.success(this.$t('campaignArchiveSuccessful'));
                this.showArchiveCampaign = false;
            } else {
                if (response.msg) {
                    toastr.error(this.$t(response.msg, response.msg_data));
                } else {
                    toastr.error(this.$t('campaignArchiveFailed'));
                }
            }
        },

        doCloneCampaign: async function () {
            const response = await cloneCampaign({
                ...this.actionCampaign,
                name: this.cloneCampaignName,
            });
            if (response.status === STATUS_OK) {
                toastr.success(this.$t('campaignCloneSuccessful'));
                this.showCloneCampaign = false;
            } else {
                if (response.msg) {
                    toastr.error(this.$t(response.msg, response.msg_data));
                } else {
                    toastr.error(this.$t('campaignCloneFailed'));
                }
            }
        },

        doDeleteCampaign: async function () {
            this.deleteInProgress = true;
            const response = await deleteCampaign(this.actionCampaign.id);
            this.deleteInProgress = false;
            if (response.status === STATUS_OK) {
                toastr.success(this.$t('campaignDeleteSuccessful'));
                this.showDeleteCampaign = false;
                // If the campaign is active we don't want it to be anymore
                if (this.actionCampaign.id === this.$store.state.campaignId) {
                    this.$store.commit('setCampaignId', {
                        campaignId: null,
                        campaignName: this.$t('none'),
                    });
                }
            } else {
                if (response.msg) {
                    toastr.error(this.$t(response.msg, response.msg_data));
                } else {
                    toastr.error(this.$t('campaignDeleteFailed'));
                }
            }
        },

        doUnarchiveCampaign: async function () {
            const response = await updateCampaign({
                ...this.actionCampaign,
                archived: false,
            });
            if (response.status === STATUS_OK) {
                toastr.success(this.$t('campaignArchiveSuccessful'));
                this.showUnarchiveCampaign = false;
            } else {
                if (response.msg) {
                    toastr.error(this.$t(response.msg, response.msg_data));
                } else {
                    toastr.error(this.$t('campaignArchiveFailed'));
                }
            }
        },

        downloadDataDump: async function (campaign) {
            if (this.downloadingId > -1) {
                toastr.info(this.$t('waitForDownload'));
            } else {
                this.downloadingId = campaign.id;
                window.location.href = `/api/campaigns/${campaign.id}/export/${this.$store.state.lang}?authorization=${this.authToken}`;
                this.downloadingId = -1;
            }
        },

        async getUnits() {
            const units = await getUnitsList();
            if (units) {
                this.units = units.payload;
            }
        },

        getCampaignDateString(campaign) {
            if (campaign.archived && campaign.last_activity) {
                return this.dateOnlyFormatter.format(
                    new Date(campaign.last_activity),
                );
            } else if (this.campaignAges[campaign.id]) {
                return this.campaignAges[campaign.id];
            }
            return this.$t('na');
        },

        getCampaignTimeString(campaign) {
            if (campaign.archived && campaign.last_activity) {
                return this.timeOnlyFormatter.format(
                    new Date(campaign.last_activity),
                );
            }
            return '';
        },

        getTotalAlerts(campaign) {
            if (campaign.total_alerts) {
                return campaign.total_alerts;
            }
            return 0;
        },

        getUnacknowledgedAlerts(campaign) {
            if (campaign.unacknowledged_alerts) {
                return campaign.unacknowledged_alerts;
            }
            return 0;
        },

        getMessageCount(campaign) {
            if (campaign.unit_message_count) {
                return campaign.unit_message_count;
            }
            return 0;
        },

        getUnitOnCampaign(campaign) {
            if (campaign.unit_name) {
                return campaign.unit_name;
            }

            return this.$t('na');
        },

        openCloneModal(campaign) {
            this.showCloneCampaign = true;
            this.actionCampaign = campaign;
            this.cloneCampaignName = this.actionCampaign.name;
            this.$nextTick(() => this.$refs.nameInput.setFocus());
        },

        promptCampaignDelete(campaign) {
            this.showDeleteCampaign = true;
            this.actionCampaign = campaign;
        },

        selectCampaign(campaign) {
            this.$router.push({ path: `/admin/campaigns/${campaign.id}` });
        },

        setSortType(type) {
            this.sortType = SORT_TYPES[type];
        },

        showArchiveModal(campaign) {
            this.actionCampaign = campaign;
            this.showArchiveCampaign = true;
        },

        showUnarchiveModal(campaign) {
            this.actionCampaign = campaign;
            this.showUnarchiveCampaign = true;
        },

        startHoldDelete() {
            this.holdDeleteStart = new Date().valueOf();
            this.deleteHoldUpdateLoop = setTimeout(this.updateHoldProgress, 25);
        },

        // Used to provide a real time counter for the time since a non-archived campaign has
        //  received its last message
        updateCampaignAges() {
            for (const campaign of this.campaignList) {
                if (campaign.last_activity) {
                    const campaignAgeDiff =
                        new Date().valueOf() -
                        new Date(campaign.last_activity).valueOf();
                    // Use set here because we want to register these object properties in Vue
                    this.campaignAges[campaign.id] = getAgeString(
                        campaignAgeDiff,
                        true,
                    );
                } else {
                    this.campaignAges[campaign.id] = this.$t('na');
                }
            }

            if (this.ageLoop) {
                this.ageLoop = setTimeout(this.updateCampaignAges, 1000);
            }
        },

        clearDeleteHolding() {
            if (this.deleteHoldUpdateLoop) {
                clearTimeout(this.deleteHoldUpdateLoop);
                this.deleteHoldUpdateLoop = null;
            }
            this.deleteHoldProgress = 0;
        },

        updateHoldProgress() {
            const timeSince =
                (new Date().valueOf() - this.holdDeleteStart) * 1.0;
            this.deleteHoldProgress =
                (timeSince / this.DELETE_HOLD_TIMEOUT) * 100;
            if (this.deleteHoldProgress > 100) {
                this.doDeleteCampaign();
                this.clearDeleteHolding();
                return;
            }

            if (this.deleteHoldUpdateLoop) {
                this.deleteHoldUpdateLoop = setTimeout(
                    this.updateHoldProgress,
                    25,
                );
            }
        },

        setSelectedAddUser(userId, username) {
            this.selectedAddUser = {
                user_id: userId,
                name: username,
            };
        },

        setSelectedAddOrganization(id, name) {
            this.selectedAddOrganization = {
                id: id,
                name: name,
            };
        },

        addOrganization() {
            // only add a organization if it isn't in the list
            if (
                !this.campaignOrganizations.some(
                    (o) => o.id === this.selectedAddOrganization.id,
                )
            ) {
                this.campaignOrganizations.push(this.selectedAddOrganization);
            }

            this.edits = true;
        },

        addManager() {
            // only add a manager if it isn't in the list
            if (
                !this.managers.some(
                    (m) => m.user_id === this.selectedAddUser.user_id,
                )
            ) {
                this.managers.push(this.selectedAddUser);
            }

            this.edits = true;
        },

        async deleteManager(manager) {
            if (this.managers) {
                this.managers = this.managers.filter(
                    (m) => m.user_id !== manager.user_id,
                );
            }

            // SRP - Commenting this out for now it needs refining because it needs to
            //      take into account other managers that could also be using the organization
            // removes organizations associated with the manager so no orgs are part of fence that don't have manager assigned.
            // const orgUser = await getOrganizationUser(manager.user_id);
            // if (orgUser.payload) {
            //     const orgId = orgUser.payload.organization_id;
            //     this.campaignOrganizations = this.campaignOrganizations.filter(
            //         (uo) => uo.id != orgId
            //     );
            // }

            this.edits = true;
        },

        deleteSelectedOrganization(id) {
            if (this.campaignOrganizations) {
                this.campaignOrganizations = this.campaignOrganizations.filter(
                    (o) => o.id !== id,
                );
            }
            this.edits = true;
        },
    },
};
</script>
